import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { RequestAccessCard , AccessCardAdd, Lookup, AccessCardCollection,AccessCardReady, PaginationModel, PagedResult} from '../models';

@Injectable()
export class RequestAccessCardService extends BaseHttpService<RequestAccessCard> {

  constructor() {
    super('request-access-card');
  }

  newAccessCard(formData: FormData): Observable<RequestAccessCard> {
    return this.httpClient
      .post(this.uri, formData, { headers: new HttpHeaders({ 'RequestWithFiles':'RequestWithFiles'})})
      .catch(this.handleError);
  }

  updateAccessCard(formData: FormData): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri, formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError);
  }


  approveByTenant(requestId: number, PO: string): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri + `${requestId}/approve-tenant`, {PO : PO})
      .catch(this.handleError)
  }

  rejectByTenant(requestId: number, comments: string): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-tenant`, { comments: comments})
      .catch(this.handleError)
  }

  markAsInProgress(requestId: number): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri + `${requestId}/in-progress`, {})
      .catch(this.handleError)
  }

  markAsReadyForCollection(requestId: number, payload: AccessCardReady): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri + `${requestId}/ready-for-collection`, JSON.stringify(payload))
      .catch(this.handleError)
  }

  markAsCollected(form: AccessCardCollection): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri + `${form.id}/collected`, JSON.stringify(form))
      .catch(this.handleError)
  }

  returnForModification(requestId: number, comments: string): Observable<RequestAccessCard> {
    return this.httpClient
      .put(this.uri + `${requestId}/return-for-modification`, { comments: comments })
      .catch(this.handleError)
  }

  getAccessCardRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number, searchVal: string }): Observable<PagedResult<RequestAccessCard>> {
    return this.httpClient
      .get(this.uri + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}&searchVal=${model.searchVal}`)
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/request-access-card.service.ts